import * as Yup from 'yup';

const expresionRegularPhoneNumber = /^[0-9]+$/;

export const getUpdateSchema = (minNumber) =>
  Yup.object().shape({
    name: Yup.string().required('Name of event is required'),
    description: Yup.string().required('Description is required'),
    hour_start_event: Yup.string().required('Event start time is required'),
    hour_vendor_setup_start: Yup.string().required('Vendor setup start time is required'),
    hour_vendor_take_down_start: Yup.string().required('Vendor take down start time is required'),
    hour_vendor_take_down_end: Yup.string().required('Vendor take down end time is required'),
    hour_end_event: Yup.string().required('Event end time is required'),
    event_date: Yup.date()
      .required('Event date is required')
      .typeError('Event date must be a valid date'),
    application_deadline: Yup.date()
      .required('Application deadline is required')
      .typeError('Application deadline date must be a valid date'),
    contact_name: Yup.string().required('Contact name is required'),
    contact_email: Yup.string('Enter your email')
      .trim()
      .email('Enter a valid email')
      .required('Contact email is required'),
    contact_phone_number: Yup.string('Enter your phone number')
      .matches(
        expresionRegularPhoneNumber,
        'Phone Number is invalid, you can only use numbers with no spaces',
      )
      .required('Contact phone number is required'),
    max_applications: Yup.number()
      .required('Field required or invalid')
      .integer('Invalid input: must be an integer')
      .test(
        'is-positive-integer',
        'Field required or invalid',
        (value) => Number.isInteger(value) && value > -1,
      )
      .min(
        minNumber,
        `Your event currently has ${minNumber} applications, use the same or a bigger number`,
      ),
  });
